import { SentryFeatureTags, logException } from "@/analytics/sentry";

import { Database } from "@punchup/data/supabase.types";
import { createClientComponentClient } from "@punchup/data/supabase/client";
import { useQuery } from "@tanstack/react-query";

export function useSubscriptions() {
  const queryFn = async () => {
    const supabase = createClientComponentClient<Database>();
    const {
      data: { user },
    } = await supabase.auth.getUser();
    if (!user) return [];
    const { data, error } = await supabase
      .from("user_comedian_follows")
      .select("comedian_id")
      .eq("user_id", user.id);
    if (error) {
      logException(error, {
        extra: {
          data: `error fetching follows for user: ${user.id}`,
        },
        tags: {
          feature: SentryFeatureTags.Subscriptions,
          supabase: true,
        },
      });
      throw error;
    }
    return data || [];
  };

  const {
    data: subscriptions = [],
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ["user", "comedian", "subscriptions"],
    queryFn,
  });

  return { subscriptions, isLoading, error, refetch };
}
